'use strict';

module.exports = {
  number: 'number',
  date: 'date',
  str: 'str',
  boolean: 'boolean',
};
